import React from 'react';
import { Tooltip, Text, Badge } from '@wix/wix-base-ui';

import { translate } from '#packages/i18n';

const CatalogCollectionLabel: React.FC = () => {
  return (
    <Tooltip
      dataHook="catalog-collection-tooltip"
      content={
        <Text enableEllipsis={false} shouldTranslate={false} size="small">
          {translate('SiteApp_WixData_DataManager_CatalogCollection_Tooltip')}
        </Text>
      }
    >
      <Badge
        dataHook="catalog-collection-badge"
        className="catalog-collection-badge"
        skin="standard"
        uppercase
        value="SiteApp_WixData_DataManager_Tab_CatalogCollection_Badge"
      />
    </Tooltip>
  );
};

export default CatalogCollectionLabel;
